function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFF200;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M0.1,621.5H10v-56H0.1v-16h41.7v16h-9.9v19.7h31.5v-19.7h-9.8v-16h41.6v16h-9.8v56h9.8v16H53.6v-16h9.8v-19.1 H31.9v19.1h9.9v16H0L0.1,621.5z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M104.3,621.5h9.9v-56h-9.9v-16h41.7v16h-9.9v56h9.9v16h-41.7V621.5z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M155.3,621.5h9.8v-56h-9.8v-16h32.1l27.6,46.6c1.5,2.7,2.7,5.6,3.7,8.6h0.4c0,0-0.7-5.8-0.7-9.8v-29.5H208v-16 h41.7v16h-9.9v72H218l-27.6-46.4c-1.5-2.9-2.8-5.9-3.7-9h-0.5c0.4,3.3,0.7,6.6,0.8,9.9v29.5h10.3v16h-41.9V621.5z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M251.5,621.5h7.3l24-72h25.2l24,72h7.2v16h-36.7v-16h7.6l-3.3-11.7h-22.4l-3.3,11.7h7.6v16h-36.9V621.5z  M301.8,593.1l-4.6-16.2c-0.8-3-1.4-6.1-1.7-9.3h-0.4c-0.3,3.1-0.9,6.2-1.8,9.3l-4.6,16.2H301.8z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M347.5,565.5h-9.8v-16h41.6v16H370v38.4c-0.1,3.4,0.6,6.7,2.1,9.7c3,4.3,8,6.7,13.2,6.3c5,0.4,9.9-2,12.8-6.1 c1.7-3,2.5-6.4,2.3-9.9v-38.4h-9.9v-16h41.7v16h-9.9v38.4c0.2,8.2-2.3,16.2-7.2,22.8c-7.7,8.3-18.7,12.8-30.1,12.2 c-11.2,0.5-22-3.8-29.9-11.8c-5.2-6.6-7.9-14.9-7.4-23.3L347.5,565.5z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M456.8,605.9v6.5c0,4.6,5.8,7.1,12.6,7.1c6.9,0,11.8-2.4,11.8-7.1c0-6.8-9.7-8.6-19-12.5 c-11.9-4.6-23.1-10.3-23.1-26.4c0-19.6,16-25.8,31.6-25.8c15.6,0,29.9,5.6,29.9,17.2v13.1H481v-5.6c0-3.4-4.6-5.2-10.2-5.2 c-5.6,0-9.4,1.5-9.4,6c0,6,7.2,8.6,15.2,11.4c13.5,4.6,26.9,10.2,26.9,26.8c0,20.1-17.2,27.6-34.3,27.6s-32.3-7.2-32.3-21.4v-11.6 H456.8z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M506.3,621.5h7.3l24-72h25.2l24,72h7.2v16h-36.7v-16h7.6l-3.3-11.7h-22.6l-3.3,11.7h7.6v16h-36.8V621.5z  M556.7,593.1l-4.6-16.2c-0.8-3-1.4-6.1-1.7-9.3l0,0c-0.3,3.1-0.9,6.2-1.8,9.3l-4.6,16.2H556.7z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M602.3,565.5h-9.8v-16h41.6v16h-9.8v38.4c-0.1,3.4,0.7,6.7,2.2,9.7c3,4.3,8,6.7,13.1,6.3c5,0.4,9.9-2,12.8-6.1 c1.7-3,2.5-6.4,2.3-9.9v-38.4h-10.1v-16h41.7v16h-9.9v38.4c0.2,8.2-2.3,16.2-7.2,22.8c-7.7,8.3-18.7,12.8-30.1,12.2 c-11.2,0.5-22-3.8-29.9-11.8c-5.2-6.6-7.9-14.9-7.4-23.3L602.3,565.5z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M708.9,621.5h9.9v-54.8h-10.5v12.5h-18.5v-29.6h79.9v29.6h-18.5v-12.5h-10.5v54.8h9.9v16h-41.7L708.9,621.5z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M819.9,548.1c24.6-0.9,45.3,18.2,46.2,42.8c0,0.7,0,1.4,0,2.1c0,25.6-20.7,46.3-46.3,46.3 c-25.5,0-46.2-20.7-46.3-46.3c-0.2-24.6,19.6-44.7,44.2-44.9C818.5,548.1,819.2,548.1,819.9,548.1z M819.9,619.9 c13.8-0.8,24.4-12.7,23.6-26.5c0-0.1,0-0.2,0-0.4c1.1-13-8.5-24.4-21.5-25.5c-13-1.1-24.4,8.5-25.5,21.5c-0.1,1.3-0.1,2.7,0,4 c-1,13.8,9.3,25.8,23.2,26.9C819.7,619.9,819.8,619.9,819.9,619.9z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M873.3,621.5h9.9v-56h-9.9v-16h38.3v16h-6.4v18.5h7.4l13-18.5h-6.7v-16H955v16h-7.4L929,590.8l0,0 c3,1.8,5.3,4.6,6.7,7.8l10,19.8c1,2,3.2,3.2,5.4,2.8h3.8v16h-15c-7.4,0-10.2-2.1-12.5-6.5l-13.1-26.8c-1.1-2.2-2.8-2.8-6.1-2.8h-3 v20.2h9.3v16h-41.1L873.3,621.5z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M962.4,621.5h9.8v-56h-9.8v-16h67.7v25.8h-18.5v-8.6h-17.2v17.9h25.8v17.2h-25.8v18.5h18.9v-8.6h18.5v25.8 h-69.5V621.5z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1059.3,605.9v6.5c0,4.6,5.8,7.1,12.6,7.1s11.8-2.4,11.8-7.1c0-6.8-9.8-8.6-19-12.5 c-11.9-4.6-23.1-10.3-23.1-26.4c0-19.6,16-25.8,31.6-25.8c15.6,0,29.9,5.6,29.9,17.2v13.1h-19.7v-5.6c0-3.4-4.7-5.2-10.2-5.2 c-5.5,0-9.4,1.5-9.4,6c0,6,7.2,8.6,15.2,11.4c13.4,4.6,26.9,10.2,26.9,26.8c0,20.1-17.2,27.6-34.3,27.6c-17.2,0-31.9-7.2-31.9-21.3 v-11.7H1059.3z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1113.6,621.5h9.9v-56h-9.9v-16h38.3v16h-6.4v18.5h7.4l13-18.5h-6.7v-16h36.1v16h-7.4l-18.6,25.2l0,0 c3,1.8,5.3,4.6,6.7,7.8l10,19.8c1.1,2,3.3,3.1,5.5,2.8h3.8v16h-15c-7.4,0-10.2-2.1-12.5-6.5l-13.1-26.8c-1.1-2.2-2.8-2.8-6.2-2.8 h-2.9v20.2h9.3v16h-41.1L1113.6,621.5z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1210.2,565.5h-9.9v-16h41.7v16h-9.9v38.4c-0.1,3.4,0.7,6.7,2.2,9.7c3,4.3,8,6.7,13.1,6.3 c5,0.4,9.9-1.9,12.8-6.1c1.7-3,2.5-6.4,2.3-9.9v-38.4h-9.8v-16h41.7v16h-9.9v38.4c0.2,8.2-2.4,16.2-7.3,22.8 c-7.7,8.3-18.7,12.8-30,12.2c-11.2,0.5-22.1-3.8-29.9-11.8c-5.2-6.6-7.9-14.9-7.4-23.3L1210.2,565.5z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1319.4,605.9v6.5c0,4.6,5.8,7.1,12.7,7.1s11.8-2.4,11.8-7.1c0-6.8-9.7-8.6-18.9-12.5 c-11.9-4.6-23.2-10.3-23.2-26.4c0-19.6,16.1-25.8,31.7-25.8c15.6,0,29.9,5.6,29.9,17.2v13.1h-19.7v-5.6c0-3.4-4.6-5.2-10.1-5.2 s-9.5,1.5-9.5,6c0,6,7.3,8.6,15.3,11.4c13.4,4.6,26.8,10.2,26.8,26.8c0,20.1-17.2,27.6-33.9,27.6c-16.7,0-32.4-7.2-32.4-21.4v-11.6 H1319.4z"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M239.8,698.1h14.6l15.7,42.3l15.7-42.3H300l-24.2,60.1h-11.7L239.8,698.1z"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M299.2,745L299.2,745c0-10,7.6-14.7,18.5-14.7c3.8,0,7.6,0.6,11.2,1.9v-0.8c0-5.4-3.3-8.6-9.9-8.6 c-4.4,0-8.7,0.8-12.7,2.5l-3.3-10c5.6-2.6,11.7-3.8,17.9-3.7c5.7-0.4,11.3,1.4,15.5,5.2c3.6,4,5.4,9.3,5,14.7v26.7h-12.6v-5 c-3.5,3.9-8.6,6.1-13.9,5.8c-7.8,0.9-14.9-4.8-15.7-12.6C299.3,746,299.2,745.5,299.2,745z M329.2,742v-2.3 c-2.7-1.2-5.6-1.8-8.6-1.7c-5.6,0-9,2.2-9,6.4l0,0c0,3.5,2.9,5.6,7.1,5.6C325.1,750.1,329.2,746.7,329.2,742L329.2,742z"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M353.4,695.5h13.1v62.7h-13.1V695.5z"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M378.6,712.2h13.1v6.5c3-4.6,8.1-7.3,13.6-7.4c5.4-0.3,10.4,2.5,13,7.3c3.6-4.7,9.1-7.4,15-7.3 c9.7,0,15.5,5.8,15.5,17.2v30h-13.1v-25.8c0-6.2-2.7-9.4-7.6-9.4c-4.9,0-7.9,3.2-7.9,9.4v25.8h-13v-25.8c0-6.2-2.7-9.4-7.6-9.4 c-4.9,0-7.9,3.2-7.9,9.4v25.8h-13.1V712.2z"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M460.6,695.5h13.7v11.6h-13.7V695.5z M460.6,712.2h13.1v46h-13.1V712.2z"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M486.5,695.5h13.7v11.6h-13.7V695.5z M486.5,712.2h13.1v46h-13.1V712.2z"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M512.2,712.2h13.1v6.5c3-4.6,8-7.3,13.5-7.4c8.3-0.4,15.4,6.1,15.8,14.4c0,0.9,0,1.8-0.1,2.7v29.8h-12.6v-25.8 c0-6.2-2.9-9.4-7.9-9.4c-5,0-8.2,3.2-8.2,9.4v25.8h-13.1L512.2,712.2z"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M562.9,745L562.9,745c0-10,7.6-14.7,18.5-14.7c3.8,0,7.6,0.6,11.2,1.9v-0.8c0-5.4-3.3-8.6-9.9-8.6 c-4.4,0-8.7,0.8-12.7,2.5l-3.3-10c5.6-2.6,11.7-3.8,17.9-3.7c5.7-0.4,11.3,1.4,15.5,5.2c3.5,4,5.3,9.3,4.9,14.7v26.7h-12.5v-5 c-3.5,3.9-8.6,6.1-13.9,5.8c-7.8,0.9-14.9-4.8-15.7-12.6C563,746,562.9,745.5,562.9,745z M592.9,742v-2.3c-2.7-1.2-5.6-1.8-8.6-1.7 c-5.6,0-9,2.2-9,6.4l0,0c0,3.5,2.9,5.6,7.1,5.6c6.4,0.2,10.8-3.2,10.8-7.9L592.9,742z"
});

var _ref27 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M639.5,745L639.5,745c0-10,7.6-14.7,18.5-14.7c3.8,0,7.6,0.6,11.2,1.9v-0.8c0-5.4-3.3-8.6-9.9-8.6 c-4.4,0-8.7,0.8-12.7,2.5l-3.3-10c5.6-2.6,11.7-3.8,17.9-3.7c5.7-0.4,11.3,1.4,15.5,5.2c3.6,4,5.4,9.3,5,14.7v26.7h-12.6v-5 c-3.5,3.9-8.6,6.1-13.9,5.8c-7.8,0.9-14.9-4.8-15.7-12.6C639.5,746,639.5,745.5,639.5,745z M669.5,742v-2.3 c-2.7-1.2-5.6-1.8-8.6-1.7c-5.6,0-8.6,2.2-8.6,6.4l0,0c0,3.5,2.9,5.6,7.1,5.6C665.4,750.1,669.5,746.7,669.5,742L669.5,742z"
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M692.7,742v-29.8h13.1V738c0,6.2,2.9,9.4,7.9,9.4s8.2-3.2,8.2-9.4v-25.8h13v46H722v-6.4c-3,4.6-8,7.3-13.5,7.4 c-8.3,0.5-15.5-5.9-15.9-14.2C692.6,744,692.6,743,692.7,742z"
});

var _ref29 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M748.7,745.2v-21.8h-5.5v-11.2h5.5v-11.8h13.1v11.8h10.8v11.2h-10.8v20c0,3,1.3,4.5,4.2,4.5 c2.2,0,4.5-0.6,6.4-1.6v10.5c-3.1,1.8-6.7,2.8-10.3,2.7C754.1,759,748.7,755.8,748.7,745.2z"
});

var _ref30 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M784.4,745.2v-21.8h-5.5v-11.2h5.5v-11.8h13.1v11.8h10.5v11.2h-10.8v20c0,3,1.3,4.5,4.2,4.5 c2.2,0,4.5-0.6,6.4-1.6v10.5c-3.1,1.8-6.7,2.8-10.3,2.7C789.8,759,784.4,755.8,784.4,745.2z"
});

var _ref31 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M815.1,745L815.1,745c0-10,7.6-14.7,18.5-14.7c3.8,0,7.6,0.6,11.2,1.9v-0.8c0-5.4-3.3-8.6-9.9-8.6 c-4.4,0-8.7,0.8-12.7,2.5l-3.3-10c5.6-2.6,11.7-3.8,17.9-3.7c5.7-0.4,11.3,1.4,15.5,5.2c3.5,4.1,5.3,9.3,4.9,14.7v26.7h-12.5v-5 c-3.5,3.9-8.6,6.1-13.9,5.8c-7.8,0.9-14.9-4.8-15.7-12.6C815.1,746,815.1,745.5,815.1,745z M845,742v-2.3c-2.7-1.2-5.6-1.8-8.6-1.7 c-5.6,0-9,2.2-9,6.4l0,0c0,3.5,2.9,5.6,7.1,5.6C840.9,750.1,845,746.7,845,742L845,742z"
});

var _ref32 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M868.7,712.2h13.1v6.5c3-4.6,8.1-7.3,13.6-7.4c5.4-0.3,10.4,2.5,12.9,7.3c3.6-4.6,9.2-7.3,15.1-7.3 c9.7,0,15.5,5.8,15.5,17.2v30h-13.1v-25.8c0-6.2-2.7-9.4-7.6-9.4s-7.9,3.2-7.9,9.4v25.8h-13v-25.8c0-6.2-2.7-9.4-7.6-9.4 c-4.9,0-7.9,3.2-7.9,9.4v25.8h-13.1V712.2z"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M947.5,745L947.5,745c0-10,7.6-14.7,18.5-14.7c3.8,0,7.6,0.6,11.2,1.9v-0.8c0-5.4-3.3-8.6-9.9-8.6 c-4.4,0-8.7,0.8-12.7,2.5l-3.3-10c5.6-2.6,11.7-3.8,17.9-3.7c5.7-0.4,11.3,1.4,15.5,5.2c3.5,4.1,5.3,9.3,4.9,14.7v26.7h-12.5v-5 c-3.5,3.9-8.6,6.1-13.9,5.8c-7.8,0.9-14.9-4.8-15.7-12.6C947.5,746,947.5,745.5,947.5,745z M977.4,742v-2.3 c-2.7-1.2-5.6-1.8-8.6-1.7c-5.6,0-9,2.2-9,6.4l0,0c0,3.5,2.9,5.6,7.1,5.6C973.3,750.1,977.4,746.7,977.4,742L977.4,742z"
});

var _ref34 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M998.3,745L998.3,745c0-10,7.6-14.7,18.5-14.7c3.8,0,7.6,0.6,11.2,1.9v-0.8c0-5.4-3.3-8.6-9.9-8.6 c-4.4,0-8.7,0.8-12.7,2.5l-3.3-10c5.6-2.6,11.7-3.8,17.9-3.7c5.7-0.4,11.3,1.4,15.5,5.2c3.5,4.1,5.3,9.3,4.9,14.7v26.7H1028v-5 c-3.5,3.9-8.6,6.1-13.9,5.8c-7.8,0.9-14.9-4.8-15.7-12.6C998.4,746,998.3,745.5,998.3,745z M1028.2,742v-2.3 c-2.7-1.2-5.6-1.8-8.6-1.7c-5.6,0-8.6,2.2-8.6,6.4l0,0c0,3.5,2.9,5.6,7.1,5.6C1024.2,750.1,1028.2,746.7,1028.2,742L1028.2,742z"
});

var _ref35 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1051.9,712.2h13.1v6.5c3-4.6,8-7.3,13.5-7.4c8.3-0.4,15.3,6,15.7,14.3c0,0.9,0,1.9-0.1,2.8v29.8h-13v-25.8 c0-6.2-2.9-9.4-7.9-9.4s-8.2,3.2-8.2,9.4v25.8h-13.1L1051.9,712.2z"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1104.9,744.5h13.9v13.7h-13.9V744.5z"
});

var _ref37 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1151.9,220.6c25.4,15.2,56,18.9,84.2,10.1c0,0-52.4-1.8-78.8-20.9C1152.1,206.2,1151.9,220.6,1151.9,220.6z"
});

var _ref38 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1084.8,232.7c2.8,5,107.1,159,61.2,154.6c-11.8-1-7.3-20.4-7.3-29.1c0-3.8-19.8-5.2-27.3-6.9 c-5.2-1.1-13.3,45.1,7.2,59c9.5,6.4,55,13.4,67.3-6.8c12.3-24,8.6-99.9,7.2-135C1153.5,273.5,1113.7,260.4,1084.8,232.7z  M1192.1,247.4c-6.4-77.3-19.9-176.2-42.9-201.8c-8.6-9.4-146.5-36.7-158.2-37.7c-13.2-1.1-81.1,41-95.7,38.7 c-18.5-2.8-211.8-20.6-259,17.2c-39.7,31.8-155.8,251.2-155.8,251.2c1.1,7.5,71.4-91.9,71.4-87.8s32.9,139.8,31.9,143.5 c-0.5,2.4-42.9,56-43.9,61.4c0.9,6.5,81.7,45.9,81.7,41.6c0-2.2,5-31.5,5-31.5l75.2-95.2c28.8,4.4,150.6-9.4,178.8-11.3 c3.9,0,65.2,107.9,65.2,107.9c1.2,10,3,19.9,5.6,29.6c4.5,3.9,96.7-14.3,101-19.3c2.3-2.7-58.1-58.6-55.8-63.2 c0,0-35.2-105.5-25-109.3c-8.6-14.9-56.3-111.1-61.4-120.2c-0.9-2.4-1.1-89.1,0.8-96.6c23.1-14.3,96.6-36.7,106-40.5 c5.7,0,33.8,23.9,33.8,23.9l-5.3,6.2c0,0-23.6-18.8-28.5-21.2c-2.4,0.5-61.1,19.8-98.7,36.2c0,2.4-1.3,85.9,0,89.4 c8.6,16.6,52.1,106,68.7,132.1c1.4-1.6,68.7-75.2,79.8-92.1c2.2-14.5,2.8-29.1,1.8-43.7c7.6-12.5,16.4-24.3,26.4-35.1l6.2,5.1 l-24,31.9c0,0,1.7,37.6-1.7,43.8c-3.4,6.2-17.2,22.9-17.2,22.9c7.8,9.2,16.6,17.5,26.3,24.7c-0.2-6.8-1.9-13.5-5-19.6 c-4.7-4.8-4.7-12.6,0.2-17.4c2.2-2.2,5.3-3.5,8.4-3.5c10.7-1.1,17.7,7,28.4,12.3C1145.9,238.3,1192.1,247.4,1192.1,247.4z  M1140.6,170.1c-4.7,0-8.6-3.8-8.6-8.6s3.8-8.6,8.6-8.6s8.6,3.8,8.6,8.6c0,4.6-3.7,8.4-8.3,8.5L1140.6,170.1z"
});

var _ref39 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M672.1,328.1c-0.9,2.1,21.8,113.3,21.5,116.6s72.3,6.8,74.7,0c-2.3-6.3-5.2-12.3-8.6-18 c0,0-14.8-90.2-16.4-100.7C740.9,314,724.2,318.2,672.1,328.1z"
});

var _ref40 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M837.7,441.7c2.4,7.2,67.1,7.8,71.2,4.3l-4.3-21.5c0,0,20.1-79.3,22.3-80.5c5.8-2.8-65.9-18.7-69.6-22.3 l-16.5,103L837.7,441.7z"
});

var _ref41 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1084.8,222.2c32,31.3,77.4,44.7,121.2,36c0,0-65.9-9.1-104.6-39.2C1086.8,211.9,1081.6,219.5,1084.8,222.2z"
});

var _ref42 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M506.8,315.4l-31.4,18c0,0-19.1-50.1-65.2-33.4c-50.9,18.3-29.3,68.7-29.3,68.7l-153.6,65.4 c0,0-3.5-58-59.4-48.6s-35.5,75.2-35.5,75.2l-14.9,3.1l-13.1-67c0,0,23.4-68.2,45.6-90.8s113.8-67.9,113.8-67.9l75.7,38.5 c0,0,14.3-5.1,17.2-6.6c3.9-4.5,55-101.5,55-101.5s3.6,1.3,2.4,2.9S369,265.5,369,265.5l98.5-36.6c0,0,2.7-1.8,4,2.1 S506.8,315.4,506.8,315.4z"
});

var _ref43 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M426.7,305.4c-23.7,0-42.9,19.2-42.9,42.9s19.2,42.9,42.9,42.9c23.7,0,42.9-19.2,42.9-42.9 S450.4,305.4,426.7,305.4z M426.7,370.5c-12.5,0-22.6-10-22.7-22.5c0-12.5,10-22.6,22.5-22.7c12.5,0,22.6,10,22.7,22.5 c0,0.1,0,0.1,0,0.2c-0.2,12.3-10.2,22.2-22.5,22.2V370.5z"
});

var _ref44 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M177.1,391.2c-23.2,0-42,18.8-42,42s18.8,42,42,42s42-18.8,42-42l0,0C219,410,200.2,391.2,177.1,391.2z  M177.1,455.7c-12.4,0-22.5-10.1-22.5-22.5c0-12.4,10.1-22.5,22.5-22.5c12.4,0,22.5,10.1,22.5,22.5c0,0,0,0,0,0 c-0.1,12.3-10.2,22.2-22.5,22.2V455.7z"
});

var SvgElkCg = function SvgElkCg(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1366 768",
    style: {
      enableBackground: "new 0 0 1366 768"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgElkCg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/elk-cg.23bacfd8.svg";
export { ForwardRef as ReactComponent };